import { Action } from '@appTypes/Action';
import {
  TradebookAdjustment,
  TradebookViewModel,
} from '@appTypes/essential-ui/TradebookAdjustmentViewModel';
import {
  RESET_TRADEBOOKS,
  SET_DEAL_INFOS,
  SET_DEFAULT_TRADEBOOKS,
  SET_PRIMARY_TRADEBOOK,
  SET_SECONDARY_TRADEBOOK,
  SET_TRADEBOOKS,
  SET_TRADEBOOKS_ADJUSTMENT,
} from './tradebookSettingsActionTypes';

interface TradebookSettingsState {
  primaryTradebook: any;
  secondaryTradebook: any;
  tradebooks: any;
  dealInfos: Array<TradebookViewModel>;
  defaultTradebooks: Array<TradebookViewModel>;
  tradebookAdjustments: Array<TradebookAdjustment>;
}

export const initialTradebookSettingsState: TradebookSettingsState = {
  primaryTradebook: null,
  secondaryTradebook: null,
  tradebooks: null,
  dealInfos: [],
  defaultTradebooks: [],
  tradebookAdjustments: [],
};

export const tradebookSettingsReducer = (
  state = initialTradebookSettingsState,
  action: Action,
): TradebookSettingsState => {
  switch (action.type) {
    case SET_PRIMARY_TRADEBOOK:
      return {
        ...state,
        primaryTradebook: action.payload,
      };
    case SET_SECONDARY_TRADEBOOK:
      return {
        ...state,
        secondaryTradebook: action.payload,
      };
    case SET_TRADEBOOKS:
      return {
        ...state,
        tradebooks: action.payload,
      };
    case SET_DEAL_INFOS:
      return {
        ...state,
        dealInfos: action.payload,
      };
    case SET_DEFAULT_TRADEBOOKS:
      return {
        ...state,
        defaultTradebooks: action.payload,
      };
    case RESET_TRADEBOOKS:
      return {
        ...state,
        primaryTradebook: null,
        secondaryTradebook: null,
        tradebooks: null,
        defaultTradebooks: [],
        tradebookAdjustments: [],
      };
    case SET_TRADEBOOKS_ADJUSTMENT:
      return {
        ...state,
        tradebookAdjustments: action.payload,
      };
    default:
      return state;
  }
};
